export const TextEffectsBauhausViewerType = 'wixui.TextEffectsBauhaus' as const;
export const TestIds = {
  viewer: {
    container: 'TextEffectsBauhaus-container',
    text: 'TextEffectsBauhaus-text',
  },
} as const;
